import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

// Legacy route: previously presented a Candidate/Recruiter choice.
// Recruiter signup is now invite-only (shared via direct /recruiter-signup link),
// so this page simply redirects any old links/bookmarks to /signup.
const SignupChoice: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const returnUrl = searchParams.get('return');
    const target = returnUrl ? `/signup?return=${encodeURIComponent(returnUrl)}` : '/signup';
    navigate(target, { replace: true });
  }, [navigate, searchParams]);

  return null;
};

export default SignupChoice;
